var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEvening = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.66,350.44c35.87,64.41,208.74,61.22,208.74,61.22l22.9-61.22S23.86,351.64,21.66,350.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.19,350.44c-35.86,64.41-183.72,61.22-183.72,61.22l-31.41-61.22S731,351.64,733.19,350.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.93,40.24,483,42.19a4.36,4.36,0,0,0,1.73,1.73L486.67,45l-1.94,1.07A4.36,4.36,0,0,0,483,47.78l-1.07,1.95-1.06-1.95a4.32,4.32,0,0,0-1.74-1.73L477.19,45l1.94-1.06a4.32,4.32,0,0,0,1.74-1.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.14,80.27l1.07,1.94A4.39,4.39,0,0,0,117.94,84L119.88,85l-1.94,1.06a4.39,4.39,0,0,0-1.73,1.74l-1.07,1.94-1.06-1.94a4.35,4.35,0,0,0-1.74-1.74L110.4,85,112.34,84a4.35,4.35,0,0,0,1.74-1.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.32,57.55l1.06,2a4.32,4.32,0,0,0,1.74,1.73l1.94,1.06-1.94,1.07a4.32,4.32,0,0,0-1.74,1.73l-1.06,2-1.06-2a4.39,4.39,0,0,0-1.74-1.73l-1.94-1.07,1.94-1.06a4.39,4.39,0,0,0,1.74-1.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.09,90.48l1.06,1.94a4.35,4.35,0,0,0,1.74,1.74l1.94,1.06-1.94,1.07A4.39,4.39,0,0,0,567.15,98L566.09,100,565,98a4.39,4.39,0,0,0-1.74-1.73l-1.94-1.07,1.94-1.06A4.35,4.35,0,0,0,565,92.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.39,33l1.82,3.32a7.48,7.48,0,0,0,3,3l3.32,1.81-3.32,1.82a7.4,7.4,0,0,0-3,3l-1.82,3.32-1.81-3.32a7.48,7.48,0,0,0-3-3l-3.32-1.82,3.32-1.81a7.57,7.57,0,0,0,3-3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.43,98.33l1.45,2.64a5.93,5.93,0,0,0,2.35,2.36l2.64,1.44-2.64,1.44a6,6,0,0,0-2.35,2.36l-1.45,2.64L240,108.57a6,6,0,0,0-2.36-2.36L235,104.77l2.64-1.44A5.89,5.89,0,0,0,240,101Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.75,46l1.44,2.64A6,6,0,0,0,692.55,51l2.64,1.44-2.64,1.44a6.08,6.08,0,0,0-2.36,2.36l-1.44,2.64-1.44-2.64A6.08,6.08,0,0,0,685,53.83l-2.64-1.44L685,51a6,6,0,0,0,2.36-2.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.87,267.65l1.44,2.63a5.83,5.83,0,0,0,2.36,2.36l2.64,1.45-2.64,1.44a5.83,5.83,0,0,0-2.36,2.36l-1.44,2.64-1.45-2.64a5.87,5.87,0,0,0-2.35-2.36l-2.64-1.44,2.64-1.45a5.87,5.87,0,0,0,2.35-2.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.09,212.81l1.45,2.64a6,6,0,0,0,2.36,2.36l2.63,1.44-2.63,1.44a5.89,5.89,0,0,0-2.36,2.36l-1.45,2.64-1.44-2.64a5.89,5.89,0,0,0-2.36-2.36l-2.64-1.44,2.64-1.44a6,6,0,0,0,2.36-2.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.89,327.74l1.44,2.64a5.93,5.93,0,0,0,2.36,2.35l2.64,1.45-2.64,1.44a6,6,0,0,0-2.36,2.36l-1.44,2.64L586.45,338a6,6,0,0,0-2.36-2.36l-2.64-1.44,2.64-1.45a6,6,0,0,0,2.36-2.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "504.55 448.3 497.89 432.3 456.56 432.3 438.69 443.63 449.22 455.96 504.55 448.3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.22 444.13 446.56 432.3 378.89 432.3 384.56 444.13 427.22 444.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.69 455.96 434.56 448.63 401 449.96 393.89 459.96 423.56 465.63 438.69 455.96",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.56 458.19 392.23 448.63 374.23 448.63 351.89 458.19 378.89 465.63 387.56 458.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.06 435.7 375.7 440.97 345.23 455.96 315.13 444.13 372.06 435.7",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "513.18 445.83 508.36 433.79 540.48 432.3 564.07 437.69 544.99 445.83 511.37 445.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.57 441.72 354.35 434.02 304.19 429.41 273.67 438.22 307.57 441.72",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.18,423.55c0,.14-146.94.26-328.16.26s-328.2-.12-328.2-.26,146.91-.26,328.2-.26S703.18,423.4,703.18,423.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sky--inject-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.53,191.61S676.3,187.41,722,198L13.53,210.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,75.82c2.68,1.63,251.05,17,288.58,15s80.44-7.41,80.44-7.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.39,51s59,9.11,78,8.45c21.48-.76,57.42-4.21,57.42-4.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.26 131.26 732.73 135.97 732.73 117.63 13.66 122.88 13.66 129.93 14.02 129.94 16.33 174.55 736.34 177.12 736.34 161.28 171.26 131.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.66 320.71 10.66 290.09 732.42 263 732.42 320.71 10.66 320.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.66 251.59 10.66 229.23 329.96 229.23 733.64 233.46 733.4 253.74 10.66 251.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.53,191.61S676.3,187.41,722,198L13.53,210.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,75.82c2.68,1.63,251.05,17,288.58,15s80.44-7.41,80.44-7.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.39,51s59,9.11,78,8.45c21.48-.76,57.42-4.21,57.42-4.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.26 131.26 732.73 135.97 732.73 117.63 13.66 122.88 13.66 129.93 14.02 129.94 16.33 174.55 736.34 177.12 736.34 161.28 171.26 131.26",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.66 320.71 10.66 290.09 732.42 263 732.42 320.71 10.66 320.71",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.66 251.59 10.66 229.23 329.96 229.23 733.64 233.46 733.4 253.74 10.66 251.59",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.69,308.68l-114.41.26s10.45-3.5,35.51-6.85c6.37-.85,43.85-2,75.76-2.79A128.9,128.9,0,0,0,275,281.09l109.33,5L268.9,293.26a128.49,128.49,0,0,0-10.77,51.64H515.86A128.84,128.84,0,0,0,510.69,308.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.69,308.68l-114.41.26s10.45-3.5,35.51-6.85c6.37-.85,43.85-2,75.76-2.79A128.9,128.9,0,0,0,275,281.09l109.33,5L268.9,293.26a128.49,128.49,0,0,0-10.77,51.64H515.86A128.84,128.84,0,0,0,510.69,308.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9,293.26a128.49,128.49,0,0,0-10.77,51.64,181,181,0,0,1,17.95-52.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,216a128.8,128.8,0,0,0-112,65l7.63.35c18.14-28.66,48.94-56.67,100.45-58.86,64.08-2.73,98.89,41,116.58,76.93l7.87-.21A128.91,128.91,0,0,0,387,216Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.92,308.69a197.15,197.15,0,0,1,11.94,36.21,128.84,128.84,0,0,0-5.17-36.22Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.7,265.77s-.16-.16-.44-.49L487,263.81c-.54-.65-1.2-1.46-2-2.4l-1.26-1.54c-.46-.54-1-1.07-1.54-1.66l-3.64-3.89c-1.37-1.39-3-2.79-4.59-4.36s-3.55-3.09-5.52-4.74-4.18-3.26-6.49-4.94-4.86-3.26-7.48-5c-1.29-.87-2.7-1.61-4.12-2.41l-4.33-2.4-4.63-2.22-2.36-1.13-2.47-1-5.05-2-5.3-1.81a126.44,126.44,0,0,0-48.48-6,140.18,140.18,0,0,0-25,4.45l-5.85,1.76c-1.92.63-3.79,1.36-5.65,2-.92.36-1.87.65-2.76,1l-2.68,1.16-2.65,1.15-1.32.56-1.27.64-5,2.51c-1.65.82-3.19,1.8-4.75,2.67-3.16,1.71-6,3.74-8.82,5.55-1.4.93-2.69,2-4,2.92l-1.94,1.44-.95.71-.9.75-3.52,3L299,250l-1.58,1.49c-2.06,2-4.11,3.78-5.82,5.71s-3.49,3.6-4.89,5.39-2.82,3.36-4,4.9l-3.13,4.3c-.47.65-.93,1.25-1.33,1.84l-1.07,1.67-1.68,2.63-1,1.61c-.23.36-.37.54-.37.54s.1-.2.33-.57.56-.93,1-1.64,1-1.61,1.64-2.65l1.05-1.69c.39-.6.85-1.2,1.31-1.86l3.11-4.33c1.18-1.55,2.56-3.17,4-4.94s3.14-3.51,4.87-5.43,3.75-3.76,5.81-5.75l1.58-1.5,1.7-1.45,3.51-3,.91-.76.95-.72,1.94-1.44c1.31-1,2.61-2,4-2.94,2.83-1.83,5.67-3.87,8.83-5.59,1.56-.88,3.11-1.86,4.76-2.7l5-2.53,1.28-.63,1.32-.58,2.65-1.15,2.69-1.16c.9-.4,1.85-.7,2.77-1.05,1.87-.67,3.74-1.4,5.67-2l5.88-1.77a139.26,139.26,0,0,1,25.13-4.48,126.37,126.37,0,0,1,48.67,6.07l5.32,1.82,5.06,2.07,2.47,1,2.37,1.15,4.64,2.24,4.34,2.42c1.41.8,2.83,1.55,4.12,2.43,2.62,1.72,5.22,3.24,7.48,5s4.55,3.27,6.49,5,3.9,3.17,5.5,4.79,3.22,3,4.57,4.4,2.53,2.74,3.62,3.92c.54.6,1.07,1.14,1.53,1.68s.86,1.07,1.24,1.56l1.95,2.43,1.19,1.51C488.57,265.59,488.7,265.77,488.7,265.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.17,295.89c0,.08-1.28.59-3.33,1.56a57.89,57.89,0,0,0-7.68,4.38l-.08.05-.21.14-.15-.2a78.71,78.71,0,0,0-5.7-6.69c-1.55-1.63-2.56-2.59-2.51-2.65s.31.18.79.59,1.17,1,2,1.8a60.48,60.48,0,0,1,5.86,6.64l-.36-.06.08-.05a46.25,46.25,0,0,1,7.82-4.28c1.06-.45,1.92-.77,2.53-1A3.79,3.79,0,0,1,107.17,295.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.36,297.39a5.44,5.44,0,0,1-1,.42c-.68.24-1.65.59-2.85,1.06a68.91,68.91,0,0,0-9,4.29l-.62.36-.19.11-.14-.16a68,68,0,0,0-6.83-6.61c-1.86-1.55-3.06-2.43-3-2.5a4.25,4.25,0,0,1,.91.54c.57.37,1.37.94,2.33,1.68a54,54,0,0,1,7,6.54l-.33-.05.64-.36a55.32,55.32,0,0,1,9.15-4.19c1.21-.42,2.21-.72,2.91-.9A3.81,3.81,0,0,1,260.36,297.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.61,250.19c0,.08-1.52.62-3.87,1.83a36,36,0,0,0-8.33,6l-.18.18-.18-.18-.18-.18c-2.92-2.91-5.54-5.56-7.42-7.5L541.24,248a4.67,4.67,0,0,1-.76-.9,6.31,6.31,0,0,1,.9.76l2.33,2.19c1.94,1.87,4.61,4.49,7.53,7.39l.18.18h-.37a32.42,32.42,0,0,1,8.53-6,24.37,24.37,0,0,1,2.91-1.2A4.73,4.73,0,0,1,563.61,250.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.3,188.64a16,16,0,0,0-2.6,2,10,10,0,0,0-2.82,7.31l0,.51-.42-.28-1.28-.85a46.55,46.55,0,0,1-7.09-6c-.82-.86-1.45-1.59-1.87-2.1a3.94,3.94,0,0,1-.6-.85c.06,0,1,1.05,2.74,2.69a55.7,55.7,0,0,0,7.12,5.86c.43.29.86.57,1.26.85l-.4.23a10,10,0,0,1,3.1-7.58,8.68,8.68,0,0,1,2-1.46A2.52,2.52,0,0,1,669.3,188.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.9,308.46a3.82,3.82,0,0,1-.49.82c-.39.61-.87,1.33-1.42,2.18s-1.36,2-2.26,3.2a23.31,23.31,0,0,1-3.27,3.61l-.15.12-.16-.1-1-.66a46.08,46.08,0,0,1-7.31-6.15c-.85-.88-1.49-1.63-1.93-2.16a5,5,0,0,1-.62-.86c.07,0,1.06,1.08,2.81,2.76a55.62,55.62,0,0,0,7.34,6l1,.65-.3,0a24.9,24.9,0,0,0,3.24-3.5c.9-1.15,1.68-2.22,2.33-3.11A18.09,18.09,0,0,1,227.9,308.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.94,196.77l.42,0,0-.07c-.76-1.6-14.13-30.47-.74-37,13.79-6.75,33.68,6.72,33.68,6.72s-12.53-55,22.89-64,56,55.62,56,55.62,18.31-12.48,27.28,13.79c0,0,42.68-13.77,46,33.59,0,0,14.19-8.83,12.59,4.15l-.33,2-198.47-4S65.27,196.43,74.94,196.77Z",
    style: {
      fill: "#263238",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,206.24s-.53,4.11-8.54,3.41L260,208s-20.82,4.52-32.14,0C209.45,200.62,212,186.32,212,186.32s-.94,22.23-12.72,17.52-12-20.84-12-20.84a29.36,29.36,0,0,1-21.54,17c-16.5,3.29-52.32-18.62-52.32-18.62s7.07,15.55-6.59,18.38-29.22-.94-29.22-.94,2.13,7.55-3.41,8.72l198.47,4Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,173.54a4.39,4.39,0,0,1,.6-.29c.41-.16,1-.46,1.8-.72a30.44,30.44,0,0,1,6.95-1.57,33.17,33.17,0,0,1,10.55.52A31.47,31.47,0,0,1,255.59,186a33.21,33.21,0,0,1,4.09,9.74,30.41,30.41,0,0,1,.9,7.06c0,.85-.05,1.5-.06,1.94a3.23,3.23,0,0,1-.07.67c-.05,0,0-.93-.07-2.6a34.12,34.12,0,0,0-5.2-16.56A31.47,31.47,0,0,0,234.77,172a33.47,33.47,0,0,0-10.41-.62,32.71,32.71,0,0,0-6.92,1.39C215.85,173.24,215,173.59,215,173.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.63,159.57a7.21,7.21,0,0,1,2.23,1.2,15,15,0,0,1,6.1,10.31,6.83,6.83,0,0,1,0,2.53c-.09,0-.07-1-.34-2.48a16.57,16.57,0,0,0-2.06-5.57,17,17,0,0,0-3.89-4.5C205.44,160.11,204.59,159.65,204.63,159.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.56,104.74a3.74,3.74,0,0,1,.64.35L150,106.2l1.29.81c.46.31.94.67,1.47,1,1,.77,2.28,1.59,3.52,2.65l2,1.62c.68.57,1.35,1.22,2.06,1.86,1.45,1.26,2.86,2.75,4.38,4.29a89.59,89.59,0,0,1,8.71,11,91.51,91.51,0,0,1,6.73,12.33c.82,2,1.65,3.87,2.24,5.7.31.91.65,1.78.9,2.63s.49,1.68.71,2.46c.49,1.56.77,3,1.07,4.28.13.63.28,1.22.38,1.76s.17,1.05.24,1.5c.14.86.24,1.55.32,2.08a3.54,3.54,0,0,1,.08.73,3.89,3.89,0,0,1-.18-.72c-.11-.52-.24-1.2-.42-2-.08-.45-.18-1-.28-1.49s-.28-1.12-.43-1.75c-.32-1.25-.62-2.69-1.13-4.23-.24-.78-.48-1.6-.74-2.45s-.61-1.7-.92-2.6c-.61-1.81-1.45-3.68-2.28-5.66A94.64,94.64,0,0,0,173,129.77a94.18,94.18,0,0,0-8.63-11c-1.5-1.54-2.89-3-4.32-4.31-.71-.64-1.36-1.29-2-1.87L156,111c-1.23-1.08-2.44-1.92-3.46-2.7-.52-.39-1-.76-1.44-1.08l-1.26-.84-1.73-1.19A4.51,4.51,0,0,1,147.56,104.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29,163.52a8.48,8.48,0,0,1,2,1,31.63,31.63,0,0,1,8.28,7.19,8.22,8.22,0,0,1,1.29,1.88c-.13.1-2.24-2.67-5.46-5.45S98.21,163.67,98.29,163.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.21,203.54c0-.06.32-.19.89-.18a4.05,4.05,0,0,1,2.08.69,4,4,0,0,1,1.43,1.67c.23.53.23.88.17.9a8.05,8.05,0,0,0-1.89-2.13A8.25,8.25,0,0,0,268.21,203.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.1,202.06l-.48,0,0-.08c.88-1.86,16.4-35.37.85-43-16-7.83-39.1,7.8-39.1,7.8s12.34-59.1-28.78-69.48-62.82,59.75-62.82,59.75-21.25-14.49-31.67,16c0,0-49.55-16-53.35,39,0,0-16.47-10.24-14.62,4.82l.39,2.31L694,214.55S704.33,201.66,693.1,202.06Z",
    style: {
      fill: "#263238",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.15,213.05s.62,4.78,9.92,4l5.2-1.94s24.17,5.25,37.3,0C537,206.53,534,189.93,534,189.93s1.1,25.81,14.77,20.34,13.95-24.19,13.95-24.19a34.08,34.08,0,0,0,25,19.71c19.15,3.83,60.73-21.61,60.73-21.61s-8.21,18.06,7.66,21.34,33.92-1.1,33.92-1.1-2.48,8.77,4,10.13l-230.4,4.68Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.56,175.1a5.66,5.66,0,0,1-.75-.24c-.49-.15-1.18-.47-2.12-.73a38.17,38.17,0,0,0-8-1.64,38.64,38.64,0,0,0-12.1.72,36.47,36.47,0,0,0-23.72,16.61,42.57,42.57,0,0,0-3,5.76A41.3,41.3,0,0,0,479,201a38.55,38.55,0,0,0-1.21,8.11c-.07,1,0,1.72,0,2.24s0,.78,0,.78a3.73,3.73,0,0,1-.08-.78c0-.51-.1-1.27-.06-2.25a35.66,35.66,0,0,1,1.06-8.19,40.58,40.58,0,0,1,1.75-5.45,41.54,41.54,0,0,1,3-5.84,36.46,36.46,0,0,1,24-16.83,40.92,40.92,0,0,1,6.52-.82,40.06,40.06,0,0,1,5.71.21,35.49,35.49,0,0,1,8.07,1.81c.93.29,1.61.64,2.09.82A5,5,0,0,1,530.56,175.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.55,158.88c.05.08-.95.6-2.35,1.71a19.32,19.32,0,0,0-4.54,5.21,19.68,19.68,0,0,0-2.38,6.49c-.3,1.76-.27,2.88-.37,2.88a2.71,2.71,0,0,1-.09-.78,11.53,11.53,0,0,1,.1-2.15,16.18,16.18,0,0,1,.68-3.13,18.15,18.15,0,0,1,4-6.71,16.72,16.72,0,0,1,2.41-2.11,13.73,13.73,0,0,1,1.84-1.12A2.29,2.29,0,0,1,542.55,158.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.8,95.22a5.14,5.14,0,0,1-.68.51l-2,1.37-1.46,1c-.52.37-1.07.8-1.67,1.25-1.2.91-2.6,1.88-4,3.12l-2.28,1.9c-.79.67-1.55,1.42-2.36,2.17-1.67,1.47-3.28,3.21-5,5a99,99,0,0,0-17.83,27c-1,2.29-1.93,4.46-2.64,6.57-.37,1-.77,2-1.07,3s-.58,1.93-.86,2.84c-.59,1.79-.93,3.47-1.31,4.92-.17.73-.35,1.4-.49,2l-.33,1.73c-.19,1-.35,1.79-.47,2.39a4.2,4.2,0,0,1-.2.82,5.27,5.27,0,0,1,.1-.84c.09-.6.22-1.4.37-2.41.09-.53.19-1.11.29-1.74s.29-1.31.45-2c.35-1.47.67-3.16,1.24-5,.26-.91.54-1.87.83-2.86s.68-2,1-3.05c.7-2.12,1.65-4.3,2.61-6.62a96.31,96.31,0,0,1,17.92-27.08c1.75-1.79,3.39-3.52,5.07-5,.83-.74,1.6-1.49,2.4-2.15l2.3-1.88c1.45-1.23,2.87-2.19,4.08-3.08.62-.44,1.18-.86,1.71-1.22l1.49-.94,2.07-1.29A6.35,6.35,0,0,1,608.8,95.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666,163.47a22.82,22.82,0,0,1-2.16,1.51,52.79,52.79,0,0,0-5,3.84,55,55,0,0,0-4.51,4.43,18.89,18.89,0,0,1-1.8,1.92A10.48,10.48,0,0,1,654,173a37.59,37.59,0,0,1,9.61-8.34A10,10,0,0,1,666,163.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.75,209.92a8.39,8.39,0,0,0-3.14,1.06,8.52,8.52,0,0,0-2.17,2.51c-.06,0,0-.42.22-1a4.66,4.66,0,0,1,1.66-1.92,4.78,4.78,0,0,1,2.4-.81C468.37,209.72,468.76,209.86,468.75,209.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.4,57.14H84.86L122,52s18-15.05,27.66-15.46C174.73,35.47,174,47.4,174,47.4,186.5,43.37,200.22,48.45,214.4,57.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.86 57.14 123.07 55.19 214.4 57.14 84.86 57.14",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.75,57.14h83.92l-24-5.15S588,36.94,581.71,36.53C565.45,35.47,566,47.4,566,47.4,557.83,43.37,548.94,48.45,539.75,57.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.75,57.14a131.6,131.6,0,0,1,13.2-2c5-.32,70.72,2,70.72,2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.7,150c-2.1-5.6-4.23-11.27-7.76-16.09s-8.67-8.78-14.6-9.5-12.5,2.47-14.44,8.13c-.85-12.74-2.65-25.81-9-36.87s-18.27-19.75-31-19c-12,.73-22.3,9.66-28,20.25s-7.67,22.75-9.55,34.64c-4.56-5.59-14.17-3.84-18.93,1.59s-6,13-7,20.13H443.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.75,153.31H281.39S305,150.58,313.87,151s98.48,1.13,98.48,1.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sea--inject-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.74,374.13,420,372.2l97.67-2.64L506.32,344.9H261.57L248.5,379.48l78.36,3.59L444.51,392l-197.85-6.39s-9.72,33.76-10,34.57L545,421.28l-23.79-45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74,374.13,420,372.2l97.67-2.64L506.32,344.9H261.57L248.5,379.48l78.36,3.59L444.51,392l-197.85-6.39s-9.72,33.76-10,34.57L545,421.28l-23.79-45Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.89,344.9c0,.15-163.38.26-364.87.26s-364.91-.11-364.91-.26,163.34-.26,364.91-.26S739.89,344.76,739.89,344.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.36,349.51c1.93,0,158.41,1.93,158.41,1.93l-21.14,3,12.06,2.74-25.62,1-5.78,2.65L437,363.49l-121.2,1.44,48.43-5.78-12-.86-18.85-4L356.75,353Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.61,377.11s21.47-3.85,26.65-5.55,69.93,0,69.93,0S333.54,376.25,332.61,377.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.35,382.53l53.49-1.21S365.5,376.74,356.35,382.53Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ship--inject-210"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "462.93 363.01 451.52 350.84 467.49 350.84 467.49 336.01 481.93 336.01 481.93 351.22 487.64 351.22 487.64 344.76 491.82 344.76 491.82 351.6 502.08 351.6 502.08 336.01 505.88 336.01 505.88 351.22 540.48 351.22 533.64 363.01 462.93 363.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.93 363.01 451.52 350.84 467.49 350.84 467.49 336.01 481.93 336.01 481.93 351.22 487.64 351.22 487.64 344.76 491.82 344.76 491.82 351.6 502.08 351.6 502.08 336.01 505.88 336.01 505.88 351.22 540.48 351.22 533.64 363.01 462.93 363.01",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "462.93 363.01 464.12 363.22 480.24 366.13 501.48 367.62 494.26 370.8 530.79 370.8 507.64 368.25 509.55 366.9 533.64 363.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.52 350.84 468.64 352.38 468.64 337.76 481.93 336.01 467.49 336.01 467.49 350.84 451.52 350.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.93,336a4.73,4.73,0,0,1-1.07.08l-3,.07-10.42.1.24-.24c0,2.5,0,5.25,0,8.11,0,2.37,0,4.64,0,6.75v.25h-.25L456.06,351l-3.3-.07a7,7,0,0,1-1.18-.08,6.23,6.23,0,0,1,1.18-.09l3.3-.07,11.39-.09-.25.25c0-2.11,0-4.38,0-6.75,0-2.86,0-5.61,0-8.11v-.25h.25l10.42.1,3,.07A6.4,6.4,0,0,1,481.93,336Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-210"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "617.35 423.55 682.49 462.18 704.44 462.18 631.9 423.55 617.35 423.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "617.35 423.55 682.49 462.18 704.44 462.18 631.9 423.55 617.35 423.55",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "190 423.55 134.74 463.91 155.44 463.91 203.99 423.55 190 423.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.33 423.55 55.85 463.91 30.47 463.91 101.1 423.55 118.33 423.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.05 424.12 376.12 424.12 336.87 462.46 332.58 462.46 372.05 424.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.08 424.12 221.15 424.12 173.49 462.46 169.2 462.46 217.08 424.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.63 424.12 270.7 424.12 225.72 462.46 221.43 462.46 266.63 424.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.17 424.12 320.24 424.12 277.96 462.46 273.67 462.46 316.17 424.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.01 423.38 131.08 423.38 74.46 464.08 70.17 464.08 127.01 423.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.55 423.38 180.62 423.38 126.7 464.08 122.41 464.08 176.55 423.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "603.38 423.83 607.45 423.83 670.04 462.18 665.75 462.18 603.38 423.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.42 423.83 452.48 423.83 506.66 462.18 502.37 462.18 448.42 423.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.96 423.83 502.03 423.83 558.89 462.18 554.61 462.18 497.96 423.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "547.5 423.83 551.57 423.83 611.13 462.18 606.84 462.18 547.5 423.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.86 442.66 43.18 423.81 39.11 423.81 8.86 440.38 8.86 442.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.72 423.81 88.66 423.81 11.89 464.78 16.18 464.78 92.72 423.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.86 442.66 43.18 423.81 39.11 423.81 8.86 440.38 8.86 442.66",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.72 423.81 88.66 423.81 11.89 464.78 16.18 464.78 92.72 423.81",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "732.42 461.28 658.81 423.83 654.74 423.83 729.9 462.18 732.42 462.18 732.42 461.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "708.35 423.83 704.28 423.83 732.42 437.69 732.42 435.65 708.35 423.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "372.05 424.12 376.12 424.12 336.87 462.46 332.58 462.46 372.05 424.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.08 424.12 221.15 424.12 173.49 462.46 169.2 462.46 217.08 424.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.63 424.12 270.7 424.12 225.72 462.46 221.43 462.46 266.63 424.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.17 424.12 320.24 424.12 277.96 462.46 273.67 462.46 316.17 424.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.01 423.38 131.08 423.38 74.46 464.08 70.17 464.08 127.01 423.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.55 423.38 180.62 423.38 126.7 464.08 122.41 464.08 176.55 423.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "603.38 423.83 607.45 423.83 670.04 462.18 665.75 462.18 603.38 423.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.42 423.83 452.48 423.83 506.66 462.18 502.37 462.18 448.42 423.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.96 423.83 502.03 423.83 558.89 462.18 554.61 462.18 497.96 423.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "547.5 423.83 551.57 423.83 611.13 462.18 606.84 462.18 547.5 423.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "732.42 461.28 658.81 423.83 654.74 423.83 729.9 462.18 732.42 462.18 732.42 461.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "708.35 423.83 704.28 423.83 732.42 437.69 732.42 435.65 708.35 423.83",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "190 423.55 134.74 463.91 155.44 463.91 203.99 423.55 190 423.55",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.33 423.55 55.85 463.91 30.47 463.91 101.1 423.55 118.33 423.55",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.97,
    y: 391.28,
    width: 59.99,
    height: 5.78,
    transform: "translate(307.94 788.34) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.85,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    transform: "translate(359.77 819.13) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.63,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    transform: "translate(257.33 819.13) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.03,
    y: 391.28,
    width: 172.59,
    height: 5.78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.54,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.5,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.96,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.41,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.91,
    y: 391.28,
    width: 172.59,
    height: 5.78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.41,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.38,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.83,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.29,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.97,
    y: 391.28,
    width: 83.02,
    height: 5.78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.48,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.35,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.72,
    y: 391.28,
    width: 72.8,
    height: 5.78,
    transform: "translate(124.24 788.34) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    transform: "translate(181.96 819.13) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.07,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    transform: "translate(70.21 819.13) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123.97,
    y: 391.28,
    width: 59.99,
    height: 5.78,
    transform: "translate(307.94 788.34) rotate(180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 177.85,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    transform: "translate(359.77 819.13) rotate(180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 126.63,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    transform: "translate(257.33 819.13) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 209.03,
    y: 391.28,
    width: 172.59,
    height: 5.78
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 214.54,
    y: 395.58,
    width: 4.07,
    height: 27.97
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 369.5,
    y: 395.58,
    width: 4.07,
    height: 27.97
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 319.96,
    y: 395.58,
    width: 4.07,
    height: 27.97
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 270.41,
    y: 395.58,
    width: 4.07,
    height: 27.97
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 442.91,
    y: 391.28,
    width: 172.59,
    height: 5.78
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 448.41,
    y: 395.58,
    width: 4.07,
    height: 27.97
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 603.38,
    y: 395.58,
    width: 4.07,
    height: 27.97
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 553.83,
    y: 395.58,
    width: 4.07,
    height: 27.97
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 504.29,
    y: 395.58,
    width: 4.07,
    height: 27.97
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 647.97,
    y: 391.28,
    width: 83.02,
    height: 5.78
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 653.48,
    y: 395.58,
    width: 4.07,
    height: 27.97
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 709.35,
    y: 395.58,
    width: 4.07,
    height: 27.97
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 25.72,
    y: 391.28,
    width: 72.8,
    height: 5.78,
    transform: "translate(124.24 788.34) rotate(180)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    transform: "translate(181.96 819.13) rotate(180)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 33.07,
    y: 395.58,
    width: 4.07,
    height: 27.97,
    transform: "translate(70.21 819.13) rotate(180)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M380.9,391.85c0,.14-37.54.26-83.83.26s-83.85-.12-83.85-.26,37.53-.26,83.85-.26S380.9,391.7,380.9,391.85Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.38,174s17.34,99.76,10.3,249.52H102.45s14.58-176.93,1-248.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.22,101.33q.36.11.81.27c6,2.26,23.32,13,23.32,13l2.19-2.53.47,8.42,9.45,13,3.2-9.86c1.34,1.82.83,16.27.83,16.27l3.3,12.21,5.63-13c2.8,7.41-2.71,22.27-2.71,22.27l5.82,14.13c4.25-7.68,9.43-32.42-5-54.16S53.22,101.33,53.22,101.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.19,175.68l.59-.83S94.85,144.16,67.27,141.7,24.6,155,21.19,158.18s-12.33,15-12.33,15L27.2,168s12.33-15.35,19-16.29c0,0-16.88,17.42-19.47,29.55,0,0,12.49-5.5,14.92-5.5,0,0,6.33-11.43,14.28-14.43L48.77,173,65.32,168l5.86-6,1,4.85S87,163,109.19,175.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.19,175.57c-.2,0-.43-.08-.69-.11-5.12-.64-21.6,1-21.6,1l-.65-3.07-3.42,6.9-11.55,6.9,1.29-9.67C70.93,178.5,66,190.9,66,190.9l-6.84,8.9.67-13.34c-4.73,5.06-6.17,19.93-6.17,19.93l-9.59,11c-.26-8.28,5.25-33,23.64-45.12S109.19,175.57,109.19,175.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.1,175.48C112,169.8,123.64,158,123.64,158l-3.34-2.9,7.55.44,13.64-8.14-6.22-4.53c1.94-1.15,13.48,1.49,13.48,1.49l11.27-3-8.23-4.67c7.67-2,17.78,2.76,17.78,2.76l16.25-3.59c-7.18-5-32.74-17.62-55.88-5.55s-23.64,44.78-23.64,44.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6,174.85c.2-.09,1.23.73,1.5.63,5.4-1.94,19.5.76,19.5.76l0-3.32,5.34,6.26,14.15,4.23-3.7-9.66c2,.58,10.26,12.14,10.26,12.14l10.55,9.77-3.9-13.59c2.64,3.26,10.41,16.71,10.41,16.71l13,9c-1.68-8.61-11.48-37.86-34.28-45.8S107.6,174.85,107.6,174.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.38,174s17.34,99.76,10.3,249.52H102.45s14.58-176.93,1-248.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.22,101.33q.36.11.81.27c6,2.26,23.32,13,23.32,13l2.19-2.53.47,8.42,9.45,13,3.2-9.86c1.34,1.82.83,16.27.83,16.27l3.3,12.21,5.63-13c2.8,7.41-2.71,22.27-2.71,22.27l5.82,14.13c4.25-7.68,9.43-32.42-5-54.16S53.22,101.33,53.22,101.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.19,175.68l.59-.83S94.85,144.16,67.27,141.7,24.6,155,21.19,158.18s-12.33,15-12.33,15L27.2,168s12.33-15.35,19-16.29c0,0-16.88,17.42-19.47,29.55,0,0,12.49-5.5,14.92-5.5,0,0,6.33-11.43,14.28-14.43L48.77,173,65.32,168l5.86-6,1,4.85S87,163,109.19,175.68Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.19,175.57c-.2,0-.43-.08-.69-.11-5.12-.64-21.6,1-21.6,1l-.65-3.07-3.42,6.9-11.55,6.9,1.29-9.67C70.93,178.5,66,190.9,66,190.9l-6.84,8.9.67-13.34c-4.73,5.06-6.17,19.93-6.17,19.93l-9.59,11c-.26-8.28,5.25-33,23.64-45.12S109.19,175.57,109.19,175.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.1,175.48C112,169.8,123.64,158,123.64,158l-3.34-2.9,7.55.44,13.64-8.14-6.22-4.53c1.94-1.15,13.48,1.49,13.48,1.49l11.27-3-8.23-4.67c7.67-2,17.78,2.76,17.78,2.76l16.25-3.59c-7.18-5-32.74-17.62-55.88-5.55s-23.64,44.78-23.64,44.78"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.6,174.85c.2-.09,1.23.73,1.5.63,5.4-1.94,19.5.76,19.5.76l0-3.32,5.34,6.26,14.15,4.23-3.7-9.66c2,.58,10.26,12.14,10.26,12.14l10.55,9.77-3.9-13.59c2.64,3.26,10.41,16.71,10.41,16.71l13,9c-1.68-8.61-11.48-37.86-34.28-45.8S107.6,174.85,107.6,174.85Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M199.05,250.9S184.29,316.05,190,423.55h14S192.84,303,203.86,251.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.83,204.45l-.62.27c-4.57,2.15-17.47,11.37-17.47,11.37l-2-1.61.47,6-6.3,10.08-3.57-6.74c-.9,1.41,1,11.66,1,11.66l-1.41,9L199,235.78c-1.5,5.53,4.44,15.62,4.44,15.62L200.2,262c-4.19-5.08-10.88-22.24-1.42-39S234.83,204.45,234.83,204.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,262.42l-.56-.54s8.92-23.19,30.89-27.42,35.72,5.63,38.79,7.62,11.45,9.55,11.45,9.55l-15.29-2s-11.48-9.82-16.94-9.9c0,0,15.36,10.9,18.68,19.3,0,0-10.62-2.79-12.58-2.58,0,0-6.26-7.57-13-9l6.93,7.62-13.83-2-5.33-3.73-.28,3.53S213.89,251.39,197.27,262.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.26,262.34c.15,0,.34-.09.54-.14,4.07-.91,17.51-1.2,17.51-1.2l.22-2.24,3.45,4.61,10,3.88-2-6.78c1.42.54,6.63,8.93,6.63,8.93l6.41,5.72-1.89-9.44c4.32,3.18,7,13.64,7,13.64l8.84,7c-.62-5.92-7.57-23-23.61-30S197.26,262.34,197.26,262.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,262.27c-2.9-3.79-13.47-11.13-13.47-11.13l2.39-2.36-6,1-11.82-4.57,4.55-3.78c-1.68-.65-10.71,2.26-10.71,2.26l-9.38-1.13,6.16-4.06c-6.39-.74-14,3.55-14,3.55l-13.45-1.1c5.27-4.23,24.59-15.48,44.46-9s23.57,29.78,23.57,29.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.47,261.69c-.17-.05-.92.62-1.15.58-4.54-.9-15.63,2.29-15.63,2.29l-.32-2.37-3.66,4.94-11,4.27,2-7.2c-1.55.59-7.05,9.56-7.05,9.56l-7.5,7.9,1.76-10c-1.79,2.56-6.69,12.83-6.69,12.83L139.69,292c.49-6.28,5.42-28,23-35.68S198.47,261.69,198.47,261.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.05,250.9S184.29,316.05,190,423.55h14S192.84,303,203.86,251.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M234.83,204.45l-.62.27c-4.57,2.15-17.47,11.37-17.47,11.37l-2-1.61.47,6-6.3,10.08-3.57-6.74c-.9,1.41,1,11.66,1,11.66l-1.41,9L199,235.78c-1.5,5.53,4.44,15.62,4.44,15.62L200.2,262c-4.19-5.08-10.88-22.24-1.42-39S234.83,204.45,234.83,204.45Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.27,262.42l-.56-.54s8.92-23.19,30.89-27.42,35.72,5.63,38.79,7.62,11.45,9.55,11.45,9.55l-15.29-2s-11.48-9.82-16.94-9.9c0,0,15.36,10.9,18.68,19.3,0,0-10.62-2.79-12.58-2.58,0,0-6.26-7.57-13-9l6.93,7.62-13.83-2-5.33-3.73-.28,3.53S213.89,251.39,197.27,262.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M197.26,262.34c.15,0,.34-.09.54-.14,4.07-.91,17.51-1.2,17.51-1.2l.22-2.24,3.45,4.61,10,3.88-2-6.78c1.42.54,6.63,8.93,6.63,8.93l6.41,5.72-1.89-9.44c4.32,3.18,7,13.64,7,13.64l8.84,7c-.62-5.92-7.57-23-23.61-30S197.26,262.34,197.26,262.34Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.32,262.27c-2.9-3.79-13.47-11.13-13.47-11.13l2.39-2.36-6,1-11.82-4.57,4.55-3.78c-1.68-.65-10.71,2.26-10.71,2.26l-9.38-1.13,6.16-4.06c-6.39-.74-14,3.55-14,3.55l-13.45-1.1c5.27-4.23,24.59-15.48,44.46-9s23.57,29.78,23.57,29.78"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.47,261.69c-.17-.05-.92.62-1.15.58-4.54-.9-15.63,2.29-15.63,2.29l-.32-2.37-3.66,4.94-11,4.27,2-7.2c-1.55.59-7.05,9.56-7.05,9.56l-7.5,7.9,1.76-10c-1.79,2.56-6.69,12.83-6.69,12.83L139.69,292c.49-6.28,5.42-28,23-35.68S198.47,261.69,198.47,261.69Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M234.87,233.31c9.25.38,25.28,3.28,35.83,17.46l8.61,1.12s-8.62-7.77-11.79-9.82A50.77,50.77,0,0,0,234.87,233.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,262.46l-.08-.2h0a66.26,66.26,0,0,0-3.41,19.48c-.45,20.79-1.6,60.64-1.21,84.31a282,282,0,0,0,6.42,54.1C202.07,401.91,194.93,314.34,202,262.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,256.31l-.21-.08c3.93,2.85,15.88,12.49,18.8,26.12l5,4C253.3,280.24,246.85,263.52,230.33,256.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.68,418.73l-4.38-53.8s3.25-61.66,2.19-73.08-5.58-88.46-5.58-88.46L110,178.1c-.18-1.17-.33-2.11-.44-2.78,5.71-1.62,19,.92,19,.92l0-3.32,5.34,6.26,14.15,4.23-3.7-9.66c2,.58,10.26,12.14,10.26,12.14l10.55,9.77-3.9-13.59c2.64,3.26,10.41,16.71,10.41,16.71l9,6.2a82.91,82.91,0,0,0-3.19-12.44c-3.49-10.34-14-22.43-23-26.31a130.37,130.37,0,0,0-17-6c-10.82.73-20,6.49-25.24,10.55,4.5-5.8,11.4-12.77,11.4-12.77l-3.34-2.9,7.55.44,13.64-8.14-6.22-4.53c1.54-.91,9.13.56,12.19,1.21l1.08-2.67,8.68-1.65-5.43-3.08c4.85-1.26,10.66.17,14.29,1.4l15.27-2.9-10.87-6.68c-11.21-3.73-26.33-5.61-40.54,1.8C119,136,113.17,146.26,110,155.53a58.08,58.08,0,0,0-9.51-34.16c-14.46-21.73-47.27-20-47.27-20q.36.11.81.27c6,2.26,23.32,13,23.32,13l2.19-2.53.47,8.42,9.45,13,3.2-9.86c1.34,1.81.83,16.27.83,16.27l3.3,12.21,5.63-13c2.39,6.33-1.28,18.09-2.4,21.38-7.17-8.36-18.2-17.51-32.75-18.81C39.69,139.23,24.6,155,21.19,158.18s-12.33,15-12.33,15L27.2,168s12.33-15.35,19-16.29c0,0-16.88,17.42-19.47,29.55,0,0,12.49-5.5,14.92-5.5,0,0,6.33-11.43,14.28-14.43L48.77,173,65.32,168l5.86-6,1,4.85s8.83-2.31,23.06,2.45c-8-2.3-18.33-3.07-27.47,3-18.39,12.15-23.9,36.84-23.64,45.12l9.59-11s1.44-14.87,6.17-19.93l-.67,13.34L66,190.9s4.91-12.4,6.55-13.35l-1.29,9.67,11.55-6.9,3.42-6.9.65,3.07s9.84-1,16.67-1.15c13.38,72.29-1.12,248.21-1.12,248.21h17.23c.08-1.61.15-3.2.22-4.79Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47,192.54A82.91,82.91,0,0,1,180.66,205l4,2.79c-1.68-8.61-11.48-37.86-34.28-45.8a32.35,32.35,0,0,0-12.93-1.72,130.37,130.37,0,0,1,17,6C163.45,170.11,174,182.2,177.47,192.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.49,291.85c1.06,11.42-2.19,73.08-2.19,73.08l4.38,53.8.22,0c5.68-129.62-6.82-220.82-9.87-240.66l1.88,25.29S116.42,280.44,117.49,291.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.46,144.11c.8.16,1.29.28,1.29.28l11.27-3-2.8-1.59-8.68,1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08,138.11a34.61,34.61,0,0,1,3.49,1.36l16.25-3.59a62.48,62.48,0,0,0-15.34-7.35l10.87,6.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.69,198.78a.88.88,0,0,1,.24.13l.69.45,2.62,1.74,9.56,6.51-.29.21c-1.21-4.13-2.73-9-4.68-14.21a78.81,78.81,0,0,0-3.44-8,65.28,65.28,0,0,0-5-7.83,46.8,46.8,0,0,0-13.9-12.67,39.6,39.6,0,0,0-14.67-4.54,33.77,33.77,0,0,0-10.39.44l-1.6.35-1.15.34-.71.21a.94.94,0,0,1-.25,0s.07,0,.23-.11l.7-.25,1.14-.39,1.6-.4a32.65,32.65,0,0,1,10.46-.61,39.56,39.56,0,0,1,14.87,4.49,46.55,46.55,0,0,1,14.08,12.78,63.65,63.65,0,0,1,5.09,7.9,78.33,78.33,0,0,1,3.45,8.08c1.93,5.26,3.41,10.12,4.59,14.27l.14.52-.44-.31-9.46-6.64-2.56-1.83-.66-.49A.9.9,0,0,1,171.69,198.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.56,137.34a11.12,11.12,0,0,1,2.42.84,51.38,51.38,0,0,1,5.73,2.79l.5.29-.55.18-1.95.64c-2.88.93-5.5,1.75-7.4,2.32a19.48,19.48,0,0,1-3.11.82,19.92,19.92,0,0,1,3-1.17c1.87-.66,4.47-1.53,7.35-2.47l1.95-.63-.05.47c-2.19-1.26-4.17-2.26-5.61-2.94A18.14,18.14,0,0,1,151.56,137.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.45,127.74a2.58,2.58,0,0,1,.48,0c.31,0,.78,0,1.37,0a42.86,42.86,0,0,1,5,.63,47,47,0,0,1,15.5,5.85c.73.42,1.42.89,2.08,1.31l.52.33-.61.14c-5.77,1.29-10.88,2.44-14.6,3.2a9.24,9.24,0,0,1-2.57.15,5.26,5.26,0,0,1-1.87-.52,3.56,3.56,0,0,1-1-.71c-.2-.2-.27-.32-.26-.33a6.09,6.09,0,0,0,1.33.87,7.11,7.11,0,0,0,4.3.2l14.55-3.37-.09.47c-.65-.42-1.33-.88-2.05-1.29a49.47,49.47,0,0,0-15.31-5.94c-2.07-.43-3.77-.65-4.95-.79A12.89,12.89,0,0,1,161.45,127.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.1,337.81s0-.14,0-.42,0-.7,0-1.22c0-1.1.08-2.67.14-4.69s.15-4.53.2-7.42.16-6.19.17-9.83.07-7.64,0-11.92-.11-8.86-.19-13.67c-.25-9.63-.68-20.21-1.41-31.31s-1.73-21.64-2.77-31.22c-.55-4.78-1.05-9.33-1.63-13.58s-1.09-8.2-1.62-11.8-1-6.86-1.47-9.72-.84-5.32-1.18-7.33l-.77-4.63c-.07-.51-.14-.91-.18-1.21a2.53,2.53,0,0,1,0-.41,1.45,1.45,0,0,1,.1.4l.24,1.2.86,4.61c.37,2,.81,4.46,1.27,7.32s1,6.11,1.55,9.71,1.13,7.56,1.68,11.81,1.11,8.79,1.68,13.58c1.06,9.58,2,20.14,2.81,31.24S120.73,279,121,288.63c.07,4.81.16,9.39.14,13.68s0,8.28-.1,11.92-.16,6.94-.24,9.84-.19,5.38-.29,7.42-.18,3.59-.24,4.69c0,.51,0,.92-.07,1.21A2,2,0,0,1,120.1,337.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.07,261.64a1.27,1.27,0,0,1,0,.31c0,.23,0,.52,0,.89-.06.82-.14,2-.24,3.42-.23,3-.53,7.27-.88,12.59-.68,10.62-1.4,25.32-1.6,41.57s.18,31,.62,41.6c.22,5.32.43,9.62.59,12.6.07,1.46.13,2.6.17,3.42,0,.37,0,.67,0,.89a1.43,1.43,0,0,1,0,.31,1.4,1.4,0,0,1,0-.3c0-.23,0-.52-.08-.89q-.11-1.23-.27-3.42c-.23-3-.49-7.27-.76-12.59-.54-10.64-1-25.37-.77-41.63s1-31,1.76-41.59c.38-5.31.74-9.61,1-12.57l.33-3.42c.05-.36.08-.66.11-.88A1.16,1.16,0,0,1,202.07,261.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31,251.89s-.17-.1-.45-.35l-1.21-1.08c-1-.93-2.57-2.29-4.52-3.88a77.57,77.57,0,0,0-7.13-5.2,45.12,45.12,0,0,0-9.64-4.77,67.56,67.56,0,0,0-19.31-3.11,48.53,48.53,0,0,0-5.94.26c-1.4.15-2.16.29-2.17.24a1.92,1.92,0,0,1,.54-.15c.37-.07.9-.21,1.6-.29a39.35,39.35,0,0,1,6-.42,63.4,63.4,0,0,1,19.47,3,43.64,43.64,0,0,1,9.74,4.86,72.28,72.28,0,0,1,7.1,5.32c1.93,1.63,3.42,3,4.43,4,.51.49.89.89,1.15,1.16A2.7,2.7,0,0,1,279.31,251.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.52,286.86a10.19,10.19,0,0,1-.44-1.5c-.11-.48-.27-1.07-.49-1.74s-.42-1.46-.75-2.29-.64-1.75-1.08-2.7-.92-2-1.45-3a46.46,46.46,0,0,0-4.14-6.42,48.36,48.36,0,0,0-5.18-5.62c-.89-.77-1.72-1.52-2.56-2.14s-1.62-1.22-2.35-1.72-1.42-.92-2-1.3-1.13-.68-1.57-.92a9.67,9.67,0,0,1-1.34-.79,7.45,7.45,0,0,1,1.43.61,15.4,15.4,0,0,1,1.62.85c.62.35,1.34.73,2.08,1.24s1.58,1,2.41,1.68,1.71,1.37,2.62,2.14a45.34,45.34,0,0,1,5.28,5.65,45.82,45.82,0,0,1,4.15,6.52c.52,1.07,1,2.07,1.41,3.06a29.18,29.18,0,0,1,1,2.75c.32.85.5,1.64.69,2.33a16.55,16.55,0,0,1,.41,1.78A8.15,8.15,0,0,1,254.52,286.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.2,237.21s14.64,74.5,8.7,186.34H617.35s12.31-132.13.85-185.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586,188.89c.19.07.41.16.65.27C591.37,191.39,604.8,201,604.8,201l2.1-1.67-.5,6.28L613,216.08l3.71-7c.94,1.47-1,12.13-1,12.13l1.48,9.35,6.09-9.08c1.56,5.75-4.62,16.24-4.62,16.24l3.39,11c4.36-5.29,11.32-23.15,1.48-40.6S586,188.89,586,188.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.05,249.19l.58-.56s-9.28-24.13-32.14-28.52S556.33,226,553.14,228,541.23,238,541.23,238l15.9-2.09s12-10.22,17.63-10.3c0,0-16,11.34-19.43,20.08,0,0,11-2.9,13.09-2.68,0,0,6.5-7.88,13.48-9.36l-7.2,7.92,14.39-2.11,5.54-3.88.29,3.68S607.76,237.72,625.05,249.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.06,249.11l-.56-.15c-4.23-1-18.22-1.24-18.22-1.24l-.22-2.34-3.59,4.8-10.41,4,2.1-7c-1.47.55-6.89,9.28-6.89,9.28l-6.67,5.95,2-9.82c-4.49,3.31-7.27,14.2-7.27,14.2l-9.2,7.28c.65-6.16,7.88-23.93,24.56-31.23S625.06,249.11,625.06,249.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625,249c3-3.94,14-11.57,14-11.57L636.52,235l6.28,1,12.3-4.75-4.74-3.94c1.75-.67,11.14,2.36,11.14,2.36l9.76-1.18-6.4-4.23c6.64-.76,14.61,3.7,14.61,3.7l14-1.15c-5.49-4.4-25.59-16.1-46.26-9.31s-24.53,31-24.53,31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,248.43c.18-.05,1,.65,1.2.6,4.73-.93,16.25,2.38,16.25,2.38l.34-2.46,3.81,5.14,11.42,4.45-2.08-7.5c1.61.61,7.32,10,7.32,10l7.81,8.21L668,258.77c1.87,2.66,7,13.35,7,13.35L685,280c-.51-6.54-5.64-29.12-23.91-37.13S623.8,248.43,623.8,248.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M623.2,237.21s14.64,74.5,8.7,186.34H617.35s12.31-132.13.85-185.83Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M586,188.89c.19.07.41.16.65.27C591.37,191.39,604.8,201,604.8,201l2.1-1.67-.5,6.28L613,216.08l3.71-7c.94,1.47-1,12.13-1,12.13l1.48,9.35,6.09-9.08c1.56,5.75-4.62,16.24-4.62,16.24l3.39,11c4.36-5.29,11.32-23.15,1.48-40.6S586,188.89,586,188.89Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M625.05,249.19l.58-.56s-9.28-24.13-32.14-28.52S556.33,226,553.14,228,541.23,238,541.23,238l15.9-2.09s12-10.22,17.63-10.3c0,0-16,11.34-19.43,20.08,0,0,11-2.9,13.09-2.68,0,0,6.5-7.88,13.48-9.36l-7.2,7.92,14.39-2.11,5.54-3.88.29,3.68S607.76,237.72,625.05,249.19Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M625.06,249.11l-.56-.15c-4.23-1-18.22-1.24-18.22-1.24l-.22-2.34-3.59,4.8-10.41,4,2.1-7c-1.47.55-6.89,9.28-6.89,9.28l-6.67,5.95,2-9.82c-4.49,3.31-7.27,14.2-7.27,14.2l-9.2,7.28c.65-6.16,7.88-23.93,24.56-31.23S625.06,249.11,625.06,249.11Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M625,249c3-3.94,14-11.57,14-11.57L636.52,235l6.28,1,12.3-4.75-4.74-3.94c1.75-.67,11.14,2.36,11.14,2.36l9.76-1.18-6.4-4.23c6.64-.76,14.61,3.7,14.61,3.7l14-1.15c-5.49-4.4-25.59-16.1-46.26-9.31s-24.53,31-24.53,31"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M623.8,248.43c.18-.05,1,.65,1.2.6,4.73-.93,16.25,2.38,16.25,2.38l.34-2.46,3.81,5.14,11.42,4.45-2.08-7.5c1.61.61,7.32,10,7.32,10l7.81,8.21L668,258.77c1.87,2.66,7,13.35,7,13.35L685,280c-.51-6.54-5.64-29.12-23.91-37.13S623.8,248.43,623.8,248.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M591.08,219.92l2.41.19S592.6,220,591.08,219.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.58,421a285.14,285.14,0,0,0,7.48-58c.51-30.54-1.26-105.64-1.26-105.64l-3.65-8.18h0c7.26,53.78-1.07,154.6-2.57,171.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.22,242.21c-.52.19-1.05.4-1.57.62-16.68,7.3-23.91,25.07-24.56,31.23l5.87-4.65C575.57,252.9,592.21,242.22,592.22,242.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.14,228c-3.2,2.07-11.91,9.94-11.91,9.94l9.32-1.22c13-16.63,33.56-17.18,40.53-16.83l-10.75-.85A50.93,50.93,0,0,0,553.14,228Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.9,219.27a14.2,14.2,0,0,1-1.77.23c-.58.05-1.28.12-2.08.24s-1.74.22-2.74.43a62.29,62.29,0,0,0-7,1.64A68.6,68.6,0,0,0,560,224.9a67.76,67.76,0,0,0-7.74,4.22,62.91,62.91,0,0,0-5.83,4.24c-.82.62-1.5,1.26-2.11,1.79s-1.14,1-1.55,1.41a13.24,13.24,0,0,1-1.34,1.2,11.8,11.8,0,0,1,1.2-1.34c.39-.42.88-.93,1.49-1.48s1.27-1.22,2.07-1.87a57.65,57.65,0,0,1,5.81-4.35,64,64,0,0,1,7.78-4.3,64.59,64.59,0,0,1,8.34-3.07,57.17,57.17,0,0,1,7.09-1.55c1-.18,2-.25,2.76-.35s1.52-.14,2.1-.16A10.65,10.65,0,0,1,581.9,219.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.46,242.17A10,10,0,0,1,590,243c-.47.26-1,.58-1.68,1s-1.39.84-2.17,1.41-1.65,1.14-2.53,1.85-1.8,1.47-2.76,2.3a55.38,55.38,0,0,0-5.67,6,57.07,57.07,0,0,0-4.64,6.79c-.6,1.11-1.2,2.15-1.67,3.18s-.91,2-1.28,2.86-.65,1.7-.92,2.42-.47,1.33-.62,1.85a13,13,0,0,1-.55,1.58,9.44,9.44,0,0,1,.35-1.64c.13-.52.3-1.16.54-1.89s.49-1.56.86-2.46.74-1.88,1.23-2.9,1-2.11,1.64-3.24a52.89,52.89,0,0,1,4.66-6.88,53.43,53.43,0,0,1,5.75-6c1-.83,1.9-1.62,2.82-2.28s1.78-1.29,2.59-1.82,1.56-1,2.22-1.35a18.46,18.46,0,0,1,1.74-.93A11.42,11.42,0,0,1,591.46,242.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.16,312.47a2.1,2.1,0,0,1,0-.51c0-.38,0-.86,0-1.43,0-1.33-.05-3.12-.09-5.29-.06-4.46-.16-10.62-.36-17.43s-.46-13-.66-17.42c-.09-2.17-.17-3.95-.23-5.28,0-.57,0-1.05,0-1.44a2.73,2.73,0,0,1,0-.5,1.71,1.71,0,0,1,.09.5c0,.38.08.86.14,1.43.11,1.24.24,3,.39,5.27.29,4.46.61,10.62.81,17.43s.24,13,.21,17.44c0,2.23,0,4-.08,5.29,0,.57,0,1.05,0,1.44A1.73,1.73,0,0,1,623.16,312.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Moon--inject-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.61,44.21A27.47,27.47,0,0,1,668,26.54a27.61,27.61,0,1,0,38.88,38.88,27.61,27.61,0,0,1-45.28-21.21Z",
    style: {
      fill: "#263238"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEvening);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/evening.b6eabb2230a178bc4ce87097be0ef9b7.svg";